import Vue from 'vue'
import VueRouter from 'vue-router'
Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: () => import('../views/Home.vue')
  },
  {
    path: '/about',
    name: 'About',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  },

  {
    path: '/accs',
    name: 'Accessories',
    component: () => import('../views/Accessories.vue')
  },
  {
    path: '/Divs',
    name: 'Divs',
    component: () => import('../views/Divs.vue')
  },
  {
    path: '/armour',
    name: 'Armour',
    component: () => import('../views/Armour.vue')
  },
  {
    path: '/beasts',
    name: 'Beasts',
    component: () => import('../views/Beasts.vue')
  },
  {
    path: '/flasks',
    name: 'Flasks',
    component: () => import('../views/Flasks.vue')
  },
  {
    path: '/jewels',
    name: 'Jewels',
    component: () => import('../views/Jewels.vue')
  },
  {
    path: '/prophecies',
    name: 'Prophecy',
    component: () => import('../views/Prophecy.vue')
  },
  {
    path: '/gems',
    name: 'Gems',
    component: () => import('../views/Gems.vue')
  },
  {
    path: '/weapons',
    name: 'Weapons',
    component: () => import('../views/Weapons.vue')
  },
  {
    path: '/maps',
    name: 'Maps',
    component: () => import('../views/Maps.vue')
  },
  {
    path: '/api',
    name: 'Api',
    component: () => import('../views/Api.vue')
  },
  {
    path: '/uniqueMaps',
    name: 'uniqueMaps',
    component: () => import('../views/UniqueMaps.vue')
  },
  {
    path: '/currency',
    name: 'Currency',
    component: () => import('../views/Currency.vue')
  },
  {
    path: '/essence',
    name: 'Essence',
    component: () => import('../views/Essence.vue')
  },
  {
    path: '/fossil',
    name: 'Fossil',
    component: () => import('../views/Fossils.vue')
  },
  {
    path: '/scarab',
    name: 'Scarab',
    component: () => import('../views/Scarabs.vue')
  },
  {
    path: '/deliriumOrbs',
    name: 'DeliriumOrbs',
    component: () => import('../views/DeliriumOrbs.vue')
  },
  {
    path: '/oil',
    name: 'Oils',
    component: () => import('../views/Oils.vue')
  },
  {
    path: '/harvest',
    name: 'Harvest',
    component: () => import('../views/Harvest.vue')
  },
  {
    path: '/watchstones',
    name: 'Watchstones',
    component: () => import('../views/Watchstones.vue')
  },
  {
    path: '/history',
    name: 'History',
    component: () => import('../views/History.vue')
  },
  {
    path: '/enchants',
    name: 'Enchants',
    component: () => import('../views/Enchants.vue')
  },
  {
    path: '/account',
    name: 'Account',
    component: () => import('../views/Account.vue')
  },
  {
    path: '/leagues',
    name: 'Leagues',
    component: () => import('../views/Leagues.vue')
  },
  {
    path: '/ladder',
    name: 'Ladder',
    component: () => import('../views/Ladder.vue')
  },
  {
    path: '/fragment',
    name: 'Fragments',
    component: () => import('../views/Fragments.vue')
  },
  {
    path: '/detailed/:id',
    name: 'Detailed',
    component: () => import('../views/DetailedPage.vue')
  },
  {
    path: '/compactCurrency',
    name: 'compactCurrency',
    component: () => import('../views/CompactCurrency.vue')
  },
  {
    path: '/bases',
    name: 'Bases',
    component: () => import('../views/Bases.vue')
  },
  {
    path: '/invitations',
    name: 'Invitations',
    component: () => import('../views/Invitations.vue')
  },
  {
    path: '/features',
    name: 'Features',
    component: () => import('../views/Features.vue')
  },
  {
    path: '/inscribed',
    name: 'Inscribed',
    component: () => import('../views/Inscribed.vue')
  },
  {
    path: '/sextants',
    name: 'Sextants',
    component: () => import('../views/Sextants.vue')
  },
  {
    path: '/privacy',
    name: 'Privacy',
    component: () => import('../views/Service.vue')
  },
  {
    path: '/impressum',
    name: 'impressum',
    component: () => import('../views/Imprint.vue')
  },
  {
    path: '/donation',
    name: 'donation',
    component: () => import('../views/Donation.vue')
  },

]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
